import { useHistory } from 'react-router';
import * as React from 'react';

import { History } from 'history';

export type WithInertRouterProps = {
  history: History;
  ref?: React.Ref<any>;
};

/**
 * Wraps a `Component` and adds in the `history` API prop from `react-router` without making the
 * component render on any state change to the URL.
 *
 * Should be used on components which need pop/push functions but do not depend on `location` in
 * their render method.
 */
function withInertRouter<Props extends WithInertRouterProps>(
  Component: React.ComponentType<Props>
): React.FunctionComponent<Omit<Props, keyof WithInertRouterProps>> {
  function WrapperInertRouter(inertProps) {
    const { wrappedComponentRef, ...rest } = inertProps;
    const history = useHistory();

    return <Component {...rest} history={history} ref={wrappedComponentRef} />;
  }

  WrapperInertRouter.wrappedComponent = Component;
  WrapperInertRouter.displayName = `WrapperInertRouter(${Component.displayName || 'Unknown'})`;

  return WrapperInertRouter;
}

export { withInertRouter };
